<template>
  <div class="agent-page">
    <div class="page-header">
      <div style="display: flex; flex-direction: column; text-align: start;">
        <h2 class="page-title">{{ pageTitle }}</h2>
        <h2 class="page-title" style="margin-top: 10px;">{{ title }}</h2>
      </div>
      <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回</el-button>
    </div>
    <div class="content-wrap">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px" class="bid-form">
        <div class="form-row">
          <!-- 左列 -->
          <div class="form-column">
            <el-form-item label="招标文件名称:" prop="bidInvitationDocumentsName" required>
              <el-input v-model="form.bidInvitationDocumentsName" placeholder="请输入招标文件名称"></el-input>
            </el-form-item>

            <el-form-item label="选择标段:" prop="bidSection" required>
              <el-select v-model="form.bidSection" placeholder="请选择标段" style="width: 100%">
                <el-option v-for="item in bidSectionList" :key="item.bidSectionCode" :label="item.bidSectionName"
                  :value="item.bidSectionCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开标/递交截止时间:" prop="deadline" required>
              <app-date-picker v-model="form.deadline" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss" @change="handleDeadlineChange" style="width: 100%">
              </app-date-picker>
            </el-form-item>
          </div>
          <!-- 右列 -->
          <div class="form-column">
            <el-form-item label="解密截止时间:" prop="decryptionDeadline" required>
              <app-date-picker v-model="form.decryptionDeadline" type="datetime" :disabled="!form.deadline"
                :placeholder="form.deadline ? '选择解密截止时间' : '请先选择开标/递交截止时间'" format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss" @change="handleDecryptionDeadlineChange" style="width: 100%;" />
            </el-form-item>

            <el-form-item label="质疑截止时间:" prop="questionDeadline" required>
              <app-date-picker v-model="form.questionDeadline" type="datetime" placeholder="选择质疑截止时间"
                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
            </el-form-item>
            <el-form-item label="投标限价:" prop="bidLimit" required>
              <el-input v-model="form.bidLimit" placeholder="请输入投标限价">
                <template slot="prepend">
                  <el-select v-model="form.bidLimitType" placeholder="类型" style="width: 80px;"
                    @change="handleTypeChange">
                    <el-option label="金额" :value="1"></el-option>
                    <el-option label="费率" :value="2"></el-option>
                  </el-select>
                </template>
                <template slot="append">
                  <el-select v-if="form.bidLimitType === 1" v-model="form.bidLimitUnit" placeholder="单位"
                    style="width: 80px;" @change="handleUnitChange">
                    <el-option label="元" :value="0"></el-option>
                    <el-option label="万元" :value="1"></el-option>
                  </el-select>
                  <span v-else style="padding: 0 10px;">%</span>
                </template>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="招标文件:" prop="tenderFile">
          <div class="upload-section">
            <div class="upload-buttons">
              <el-button type="primary" icon="el-icon-upload2" size="small"
                @click="handleUpload('pdf', $tenderFileType.MAIN_FILE)" :disabled="hasPdfMain">上传PDF</el-button>
              <div class="upload-tip">* 请上传pdf格式文件（仅限1份）!</div>
              <el-button type="primary" icon="el-icon-upload2" size="small"
                @click="handleUpload('word', $tenderFileType.MAIN_FILE)" :disabled="hasWordMain">上传Word</el-button>
              <div class="upload-tip">* 请上传word格式文件（仅限1份）!</div>
              <el-button type="primary" @click="showDirectoryDialog" size="small">投标文件目录</el-button>
              <div class="upload-tip">* 请制作投标文件目录</div>
              <el-button type="primary" size="small"
                @click="handleUpload('attachment', $tenderFileType.ATTACHMENT)">附件上传</el-button>
            </div>
            <!-- 已上传文件列表 -->
            <div v-if="uploadedFiles.length > 0" class="uploaded-files-list">
              <!-- 招标文件正文 -->
              <div v-if="mainFiles.length > 0" class="file-group">
                <div class="file-group-header">
                  <i class="el-icon-document"></i>
                  <span>招标文件正文</span>
                  <el-tag size="mini" type="info" style="margin-left:8px;">{{ mainFiles.length }} 份</el-tag>
                </div>
                <el-table :data="mainFiles" border size="small">
                  <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip></el-table-column>
                  <el-table-column label="格式" width="80" align="center">
                    <template slot-scope="scope">
                      <el-tag size="mini" :type="scope.row.fileType === 'pdf' ? 'danger' : 'primary'">
                        {{ scope.row.fileType.toUpperCase() }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="大小" width="90" align="center">
                    <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
                  </el-table-column>
                  <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" style="color:#F56C6C;"
                        @click="handleDeleteFile(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 附件 -->
              <div v-if="attFiles.length > 0" class="file-group">
                <div class="file-group-header">
                  <i class="el-icon-paperclip"></i>
                  <span>附件</span>
                  <el-tag size="mini" type="info" style="margin-left:8px;">{{ attFiles.length }} 份</el-tag>
                </div>
                <el-table :data="attFiles" border size="small">
                  <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip></el-table-column>
                  <el-table-column label="格式" width="80" align="center">
                    <template slot-scope="scope">
                      <el-tag size="mini"
                        :type="scope.row.fileType === 'pdf' ? 'danger' : scope.row.fileType === 'docx' || scope.row.fileType === 'doc' ? 'primary' : 'warning'">
                        {{ scope.row.fileType.toUpperCase() }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="大小" width="90" align="center">
                    <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
                  </el-table-column>
                  <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" style="color:#F56C6C;"
                        @click="handleDeleteFile(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-form-item>
        <!-- 开标一览表 -->
        <div class="opening-summary">
          <div class="summary-title">开标一览表:</div>
          <!-- 双信封Tab切换 -->
          <div v-if="isDoubleEnvelope" class="envelope-tabs">
            <span class="envelope-tab" :class="{ active: activeEnvelopeTab === '1' }"
              @click="activeEnvelopeTab = '1'">一信封</span>
            <span class="envelope-tab" :class="{ active: activeEnvelopeTab === '2' }"
              @click="activeEnvelopeTab = '2'">二信封</span>
          </div>
          <el-table :data="currentOpeningSummaryData" border>
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name" size="small" placeholder="请输入名称">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="valueType" label="数值类型">
              <template slot-scope="scope">
                <span>{{ scope.row.valueType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="单位">
              <template slot-scope="scope">
                <el-input v-model="scope.row.unit" size="small" placeholder="请输入单位">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="instructions" label="填写说明">
              <template slot-scope="scope">
                <el-input v-model="scope.row.instructions" size="small" placeholder="请输入填写说明">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <!-- 眼睛图标：仅总价行显示 -->
                <el-tooltip v-if="scope.row.type === '总价'" :content="scope.row.hide === 1 ? '已隐藏' : '已开启'" placement="top">
                  <el-button type="text" size="small" @click="togglehide(scope.$index)">
                    <i :class="scope.row.hide === 1 ? 'el-icon-view' : 'el-icon-view'"
                      :style="{ opacity: scope.row.hide === 1 ? 0.3 : 1 }"></i>
                  </el-button>
                </el-tooltip>
                <el-button type="text" size="small" @click="deleteSummaryItem(scope.$index)">
                  <i class="el-icon-delete"></i>
                </el-button>
                <el-button v-if="scope.$index > 0" type="text" size="small"
                  @click="moveSummaryItem(scope.$index, 'up')">
                  <i class="el-icon-top"></i>
                </el-button>
                <el-button v-if="scope.$index < currentOpeningSummaryData.length - 1" type="text" size="small"
                  @click="moveSummaryItem(scope.$index, 'down')">
                  <i class="el-icon-bottom"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="add-summary-btn">
            <el-button type="primary" size="small" @click="showAddDialog">添加自定义开标内容</el-button>
          </div>
        </div>

        <!-- 底部按钮 -->
        <div class="form-actions">
          <el-button @click="handleSubmit(0)">暂存</el-button>
          <el-button type="primary" @click="handleSubmit(1)">提交</el-button>
        </div>
      </el-form>
    </div>
    <!-- 添加自定义开标内容弹窗 -->
    <el-dialog title="消息确认" :visible.sync="dialogs.add" width="500px" :close-on-click-modal="false"
      :append-to-body="true" class="add-dialog">
      <div class="dialog-content">
        <div class="dialog-title">*添加自定义内容的类型:</div>
        <el-radio-group v-model="addDialogData.selectedType" class="type-radio-group">
          <div class="radio-row">
            <el-radio label="总价">总价</el-radio>
            <el-radio label="费率">费率</el-radio>
            <el-radio label="单价">单价</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="证书编号">证书编号</el-radio>
            <el-radio label="交货地点">交货地点</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="期限(服务/交货/工期)">期限(服务/交货/工期)</el-radio>
            <el-radio label="其它">其它</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="姓名">姓名</el-radio>
            <el-radio label="质量标准">质量标准</el-radio>
          </div>
        </el-radio-group>
        <div v-if="!addDialogData.selectedType" class="error-message">请选择自定义内容的类型</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmAdd">确认</el-button>
        <el-button @click="cancelAdd">取消</el-button>
      </div>
    </el-dialog>
    <!-- 选择引用的招标文件弹窗 -->
    <el-dialog title="选择引用的招标文件" :visible.sync="dialogs.reference" width="700px" :append-to-body="true"
      class="reference-dialog">
      <div class="dialog-content">
        <el-table :data="referenceData.tableData" v-loading="referenceData.loading" border style="width: 100%"
          class="reference-table">
          <el-table-column prop="no" label="NO." width="60" align="center" />
          <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip />
          <el-table-column label="详细信息" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleSelectReference(scope.row)" class="select-btn">
                选择引用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="reference-pagination">
          <el-pagination @size-change="handleReferenceSizeChange" @current-change="handleReferenceCurrentChange"
            :current-page="referenceData.pagination.currentPage" :page-sizes="[10, 20, 50, 100]"
            :page-size="referenceData.pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="referenceData.pagination.total" class="reference-pagination-controls" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelReference">取消</el-button>
      </div>
    </el-dialog>
    <!-- 投标文件目录目录管理弹窗 -->
    <el-dialog title="投标文件目录目录管理" :visible.sync="dialogs.directory" width="60%" :append-to-body="true"
      class="directory-dialog">
      <div class="dialog-content">
        <!-- 双信封Tab切换 -->
        <div v-if="isDoubleEnvelope" class="envelope-tabs" style="margin-bottom:15px;">
          <span class="envelope-tab" :class="{ active: activeDirectoryEnvelopeTab === '1' }"
            @click="activeDirectoryEnvelopeTab = '1'">一信封</span>
          <span class="envelope-tab" :class="{ active: activeDirectoryEnvelopeTab === '2' }"
            @click="activeDirectoryEnvelopeTab = '2'">二信封</span>
        </div>
        <div class="directory-toolbar" v-if="!isBlindReviewEnabled || !IS_BLIND_DIRECTORY_ENABLED">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addRootDirectory">添加目录</el-button>
          <el-button size="small" icon="el-icon-document-copy" @click="openPasteDirectoryDialog">粘贴目录</el-button>
        </div>
        <div class="directory-block" v-if="isBlindReviewEnabled && IS_BLIND_DIRECTORY_ENABLED">
          <div class="directory-block-header">
            <div>
              <div class="directory-block-title">明标文件目录</div>
              <div class="directory-block-tip">用于维护明标部分的投标文件目录结构</div>
            </div>
            <div class="directory-toolbar compact">
              <el-button type="primary" size="small" icon="el-icon-plus"
                @click="addRootDirectory('normal')">添加目录</el-button>
              <el-button size="small" icon="el-icon-document-copy"
                @click="openPasteDirectoryDialog('normal')">粘贴目录</el-button>
            </div>
          </div>
          <div class="directory-tree">
            <div v-if="currentDirectoryTreeData.length === 0" class="empty-directory">
              <i class="el-icon-folder-opened"></i>
              <p>暂无目录</p>
            </div>
            <div v-else class="directory-list">
              <div v-for="(item, index) in currentDirectoryTreeData" :key="item.id" class="directory-item">
                <div class="directory-node">
                  <i class="el-icon-folder"></i>
                  <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === item.id"
                    v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(item)"
                    @keyup.enter.native="saveDirectoryName(item)" ref="directoryInput" class="directory-input">
                  </el-input>
                  <span v-else class="directory-name">{{ item.name }}</span>
                  <div class="directory-actions">
                    <el-button type="text" size="small" icon="el-icon-edit" @click="editDirectoryName(item)"
                      v-if="!directoryData.editingNode || directoryData.editingNode.id !== item.id">
                    </el-button>
                    <el-button type="text" size="small" icon="el-icon-plus" @click="addChildDirectory(item)">
                    </el-button>
                    <el-button type="text" size="small" icon="el-icon-delete" @click="deleteDirectory(item, index)">
                    </el-button>
                  </div>
                </div>
                <div v-if="item.children && item.children.length > 0" class="directory-children">
                  <div v-for="(child, childIndex) in item.children" :key="child.id" class="directory-item child-item">
                    <div class="directory-node">
                      <i class="el-icon-folder"></i>
                      <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === child.id"
                        v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(child)"
                        @keyup.enter.native="saveDirectoryName(child)" ref="directoryInput" class="directory-input">
                      </el-input>
                      <span v-else class="directory-name">{{ child.name }}</span>
                      <div class="directory-actions">
                        <el-button type="text" size="small" icon="el-icon-edit" @click="editDirectoryName(child)"
                          v-if="!directoryData.editingNode || directoryData.editingNode.id !== child.id">
                        </el-button>
                        <el-button type="text" size="small" icon="el-icon-plus" @click="addChildDirectory(child)">
                        </el-button>
                        <el-button type="text" size="small" icon="el-icon-delete"
                          @click="deleteChildDirectory(item, child, childIndex)">
                        </el-button>
                      </div>
                    </div>
                    <div v-if="child.children && child.children.length > 0" class="directory-children">
                      <div v-for="(grandchild, grandchildIndex) in child.children" :key="grandchild.id"
                        class="directory-item grandchild-item">
                        <div class="directory-node">
                          <i class="el-icon-folder"></i>
                          <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === grandchild.id"
                            v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(grandchild)"
                            @keyup.enter.native="saveDirectoryName(grandchild)" ref="directoryInput"
                            class="directory-input">
                          </el-input>
                          <span v-else class="directory-name">{{ grandchild.name }}</span>
                          <div class="directory-actions">
                            <el-button type="text" size="small" icon="el-icon-edit"
                              @click="editDirectoryName(grandchild)"
                              v-if="!directoryData.editingNode || directoryData.editingNode.id !== grandchild.id">
                            </el-button>
                            <el-button type="text" size="small" icon="el-icon-delete"
                              @click="deleteGrandchildDirectory(child, grandchild, grandchildIndex)">
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="directory-block blind-directory" v-if="isBlindReviewEnabled && IS_BLIND_DIRECTORY_ENABLED">
          <div class="directory-block-header">
            <div>
              <div class="directory-block-title">暗标目录</div>
            </div>
            <div class="directory-toolbar compact">
              <!-- <span class="directory-block-tip" style="color:#909399;">暗标无需设置目录</span> -->
            </div>
          </div>
          <div class="directory-tree blind-tree">
            <div v-if="currentBlindTreeData.length === 0" class="empty-directory">
              <i class="el-icon-folder-opened"></i>
              <p>暗标无需设置目录</p>
            </div>
            <div v-else class="directory-list">
              <div v-for="(item, index) in currentBlindTreeData" :key="item.id" class="directory-item">
                <div class="directory-node">
                  <i class="el-icon-folder"></i>
                  <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === item.id"
                    v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(item)"
                    @keyup.enter.native="saveDirectoryName(item)" ref="directoryInput" class="directory-input">
                  </el-input>
                  <span v-else class="directory-name">{{ item.name }}</span>
                  <div class="directory-actions">
                    <el-button type="text" size="small" icon="el-icon-edit" @click="editDirectoryName(item)"
                      v-if="!directoryData.editingNode || directoryData.editingNode.id !== item.id">
                    </el-button>
                    <el-button type="text" size="small" icon="el-icon-plus" @click="addChildDirectory(item)">
                    </el-button>
                    <el-button type="text" size="small" icon="el-icon-delete"
                      @click="deleteBlindDirectory(item, index)">
                    </el-button>
                  </div>
                </div>
                <div v-if="item.children && item.children.length > 0" class="directory-children">
                  <div v-for="(child, childIndex) in item.children" :key="child.id" class="directory-item child-item">
                    <div class="directory-node">
                      <i class="el-icon-folder"></i>
                      <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === child.id"
                        v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(child)"
                        @keyup.enter.native="saveDirectoryName(child)" ref="directoryInput" class="directory-input">
                      </el-input>
                      <span v-else class="directory-name">{{ child.name }}</span>
                      <div class="directory-actions">
                        <el-button type="text" size="small" icon="el-icon-edit" @click="editDirectoryName(child)"
                          v-if="!directoryData.editingNode || directoryData.editingNode.id !== child.id">
                        </el-button>
                        <el-button type="text" size="small" icon="el-icon-plus" @click="addChildDirectory(child)">
                        </el-button>
                        <el-button type="text" size="small" icon="el-icon-delete"
                          @click="deleteChildDirectory(item, child, childIndex)">
                        </el-button>
                      </div>
                    </div>
                    <div v-if="child.children && child.children.length > 0" class="directory-children">
                      <div v-for="(grandchild, grandchildIndex) in child.children" :key="grandchild.id"
                        class="directory-item grandchild-item">
                        <div class="directory-node">
                          <i class="el-icon-folder"></i>
                          <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === grandchild.id"
                            v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(grandchild)"
                            @keyup.enter.native="saveDirectoryName(grandchild)" ref="directoryInput"
                            class="directory-input">
                          </el-input>
                          <span v-else class="directory-name">{{ grandchild.name }}</span>
                          <div class="directory-actions">
                            <el-button type="text" size="small" icon="el-icon-edit"
                              @click="editDirectoryName(grandchild)"
                              v-if="!directoryData.editingNode || directoryData.editingNode.id !== grandchild.id">
                            </el-button>
                            <el-button type="text" size="small" icon="el-icon-delete"
                              @click="deleteGrandchildDirectory(child, grandchild, grandchildIndex)">
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="directory-tree" v-else>
          <div v-if="currentDirectoryTreeData.length === 0" class="empty-directory">
            <i class="el-icon-folder-opened"></i>
            <p>暂无目录</p>
          </div>
          <div v-else class="directory-list">
            <div v-for="(item, index) in currentDirectoryTreeData" :key="item.id" class="directory-item">
              <div class="directory-node">
                <i class="el-icon-folder"></i>
                <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === item.id"
                  v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(item)"
                  @keyup.enter.native="saveDirectoryName(item)" ref="directoryInput" class="directory-input">
                </el-input>
                <span v-else class="directory-name">{{ item.name }}</span>
                <div class="directory-actions">
                  <el-button type="text" size="small" icon="el-icon-edit" @click="editDirectoryName(item)"
                    v-if="!directoryData.editingNode || directoryData.editingNode.id !== item.id">
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-plus" @click="addChildDirectory(item)">
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-delete" @click="deleteDirectory(item, index)">
                  </el-button>
                </div>
              </div>
              <!-- 子目录 -->
              <div v-if="item.children && item.children.length > 0" class="directory-children">
                <div v-for="(child, childIndex) in item.children" :key="child.id" class="directory-item child-item">
                  <div class="directory-node">
                    <i class="el-icon-folder"></i>
                    <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === child.id"
                      v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(child)"
                      @keyup.enter.native="saveDirectoryName(child)" ref="directoryInput" class="directory-input">
                    </el-input>
                    <span v-else class="directory-name">{{ child.name }}</span>
                    <div class="directory-actions">
                      <el-button type="text" size="small" icon="el-icon-edit" @click="editDirectoryName(child)"
                        v-if="!directoryData.editingNode || directoryData.editingNode.id !== child.id">
                      </el-button>
                      <el-button type="text" size="small" icon="el-icon-plus" @click="addChildDirectory(child)">
                      </el-button>
                      <el-button type="text" size="small" icon="el-icon-delete"
                        @click="deleteChildDirectory(item, child, childIndex)">
                      </el-button>
                    </div>
                  </div>
                  <!-- 三级子目录 -->
                  <div v-if="child.children && child.children.length > 0" class="directory-children">
                    <div v-for="(grandchild, grandchildIndex) in child.children" :key="grandchild.id"
                      class="directory-item grandchild-item">
                      <div class="directory-node">
                        <i class="el-icon-folder"></i>
                        <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === grandchild.id"
                          v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(grandchild)"
                          @keyup.enter.native="saveDirectoryName(grandchild)" ref="directoryInput"
                          class="directory-input">
                        </el-input>
                        <span v-else class="directory-name">{{ grandchild.name }}</span>
                        <div class="directory-actions">
                          <el-button type="text" size="small" icon="el-icon-edit" @click="editDirectoryName(grandchild)"
                            v-if="!directoryData.editingNode || directoryData.editingNode.id !== grandchild.id">
                          </el-button>
                          <el-button type="text" size="small" icon="el-icon-delete"
                            @click="deleteGrandchildDirectory(child, grandchild, grandchildIndex)">
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmDirectory">确认</el-button>
        <el-button @click="cancelDirectory">取消</el-button>
      </div>
    </el-dialog>

    <!-- 粘贴目录弹窗 -->
    <el-dialog title="粘贴目录" :visible.sync="dialogs.pasteDirectory" width="640px" :append-to-body="true"
      class="paste-directory-dialog" :close-on-click-modal="false">
      <div class="paste-directory-content">
        <div class="paste-directory-tip">支持格式示例：一、法定代表人身份证明书 / 1、营业执照 / 二、授权委托书</div>
        <el-input type="textarea" :rows="12" v-model="directoryData.pasteContent"
          placeholder="请粘贴目录文本，一行一个目录"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmPasteDirectory">确定</el-button>
        <el-button @click="cancelPasteDirectory">取消</el-button>
      </div>
    </el-dialog>

    <!-- 暗标编制要求弹窗 -->
    <el-dialog title="暗标编制要求" :visible.sync="dialogs.blindRequirement" width="640px" :append-to-body="true"
      :close-on-click-modal="false" class="blind-requirement-dialog">
      <el-input type="textarea" v-model="form.remark" :rows="10" :maxlength="1000" show-word-limit
        placeholder="请输入暗标编制要求"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogs.blindRequirement = false">确定</el-button>
        <el-button @click="dialogs.blindRequirement = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 文件上传进度对话框 -->
    <el-dialog title="文件上传" :visible.sync="uploadProgress.visible" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" :show-close="false">
      <div class="upload-progress-content">
        <div class="upload-info">
          <i class="el-icon-upload" style="font-size: 24px; color: #409EFF; margin-right: 10px;"></i>
          <span>{{ uploadProgress.fileName }}</span>
        </div>
        <el-progress :percentage="uploadProgress.percentage"
          :status="uploadProgress.status === uploadConstants.UPLOAD_STATUS.SUCCESS ? 'success' : (uploadProgress.status === uploadConstants.UPLOAD_STATUS.ERROR ? 'exception' : null)"
          style="margin-top: 20px;">
        </el-progress>
        <div class="upload-status" style="margin-top: 10px; text-align: center;">
          <span v-if="uploadProgress.status === uploadConstants.UPLOAD_STATUS.UPLOADING">正在上传...</span>
          <span v-else-if="uploadProgress.status === uploadConstants.UPLOAD_STATUS.SUCCESS"
            style="color: #67C23A;">上传成功</span>
          <span v-else-if="uploadProgress.status === uploadConstants.UPLOAD_STATUS.ERROR"
            style="color: #F56C6C;">上传失败</span>
        </div>
        <!-- 上传速度 + 已上传/总大小 -->
        <div class="upload-speed"
          v-if="uploadProgress.status === uploadConstants.UPLOAD_STATUS.UPLOADING && uploadProgress.fileSize > 0"
          style="margin-top: 8px; text-align: center; font-size: 13px; color: #909399;">
          <span>{{ uploadProgress.speedText || '计算中...' }}</span>
          <span style="margin: 0 6px; color: #DCDFE6;">|</span>
          <span>{{ formatFileSize(uploadProgress.loaded) }} / {{ formatFileSize(uploadProgress.fileSize) }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProjectDetail, initBidInvitationDocumentsData, addBidInvitationDocuments, getBidInvitationDocumentsDetail } from '@/api/modules/agent'
import { getProjectTypeName, timeUtils, UPLOAD_CONSTANTS, BUSINESS_CONSTANTS } from '@/utils/base'
import { getFileList } from '@/api/modules/base'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import { deleteBidAtt } from '@/api/modules/make'
// 设置Element UI语言
Vue.use(ElementUI, { locale })
export default {
  name: 'CreatBidFile',
  data() {
    return {
      // 是否填写暗标目录（暂时写死 不填写）
      IS_BLIND_DIRECTORY_ENABLED: true,
      // 双信封相关
      activeEnvelopeTab: '1', // 开标一览表当前信封Tab（'1':一信封, '2':二信封）
      activeDirectoryEnvelopeTab: '1', // 目录当前信封Tab（'1':一信封, '2':二信封）
      // 页面基础信息
      pageTitle: '',
      title: '新增招标文件',
      projectCode: '',

      // 项目详情数据
      projectDetail: {},

      // 标段列表
      bidSectionList: [],

      // 加载状态
      loading: false,
      isBlindReview: 0,

      // 表单数据
      form: {
        projectName: '',
        bidInvitationDocumentsName: '',
        bidSection: '', // 单选标段，存储标段编码
        deadline: '',
        bidLimit: '',
        bidLimitType: 1, // 招标控制价类型（1：金额、2：费率）
        bidLimitUnit: 0, // 招标控制价单位（0：元，1：万元）
        tenderFile: '',
        isBlindBid: false,
        decryptionDeadline: '',
        referenceFile: '',
        questionDeadline: '',
        remark: '',
      },

      // 开标一览表数据-一信封（双信封模式：只有工期、质量标准）
      openingSummaryData: [
        {
          name: '工期',
          valueType: '任意格式文本',
          unit: '',
          instructions: '',
          type: '期限(服务/交货/工期)'
        },
        {
          name: '质量标准',
          valueType: '任意格式文本',
          unit: '',
          instructions: '',
          type: '其它'
        }
      ],

      // 开标一览表数据-非双信封（保持原样）
      openingSummaryDataNormal: [
        {
          name: '总价',
          valueType: '数字含小数',
          unit: '元',
          instructions: '',
          type: '总价',
          hide: 0
        },
        {
          name: '总价(大写)',
          valueType: '任意格式文本',
          unit: '元',
          instructions: '',
          type: '其它',
          hide: 0
        },
        {
          name: '工期',
          valueType: '任意格式文本',
          unit: '',
          instructions: '',
          type: '期限(服务/交货/工期)',
          hide: 0
        },
        {
          name: '质量标准',
          valueType: '任意格式文本',
          unit: '',
          instructions: '',
          type: '其它',
          hide: 0
        }
      ],

      // 开标一览表数据-二信封（默认只保留总价和总价大写）
      openingSummaryDataEnvelope2: [
        {
          name: '总价',
          valueType: '数字含小数',
          unit: '元',
          instructions: '',
          type: '总价',
          hide: 0
        },
        {
          name: '总价(大写)',
          valueType: '任意格式文本',
          unit: '元',
          instructions: '',
          type: '其它',
          hide: 0
        }
      ],

      // 弹窗控制
      dialogs: {
        add: false,
        reference: false,
        directory: false,
        pasteDirectory: false,
        blindRequirement: false
      },

      // 添加弹窗相关数据
      addDialogData: {
        selectedType: ''
      },

      // 引用弹窗相关数据
      referenceData: {
        loading: false,
        tableData: [
          {
            no: 1,
            fileName: ''
          }
        ],
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 1
        }
      },

      // 目录管理相关数据
      directoryData: {
        treeData: [], // 目录树数据（一信封/非双信封）
        treeDataEnvelope2: [], // 二信封目录树数据
        blindTreeData: [], // 暗标目录树数据（一信封/非双信封）
        blindTreeDataEnvelope2: [], // 二信封暗标目录树数据
        editingNode: null, // 正在编辑的节点
        editingName: '', // 编辑中的目录名称
        pasteContent: '', // 粘贴目录文本
        pasteTarget: 'normal'
      },

      // 操作状态
      operationStatus: {
        isSubmitting: false
      },

      // 文件上传相关数据
      fileBindId: '', // 文件绑定ID
      uploadedFiles: [], // 已上传文件列表
      tenderFileType: '', // 文件类型标识（main_file 或 attachment）
      uploadProgress: {
        visible: false, // 是否显示上传进度弹窗
        percentage: 0, // 上传进度
        fileName: '', // 文件名称
        fileSize: 0, // 文件总大小（字节）
        loaded: 0, // 已上传字节数
        speed: 0, // 当前上传速度（字节/秒，平滑后）
        speedText: '', // 速度文本（如 1.2 MB/s）
        startTime: null, // 上传开始时间戳
        lastUpdateTime: null, // 上一次进度更新时间
        lastLoaded: 0, // 上一次进度时的已上传字节
        status: null // 上传状态
      },
      uploadConstants: {
        ...UPLOAD_CONSTANTS,
        ...BUSINESS_CONSTANTS,
        UPLOAD_STATUS: UPLOAD_CONSTANTS.STATUS
      },

      // 类型对应的数据格式配置
      typeConfig: {
        '总价': { valueType: '数字含小数', unit: '元' },
        '费率': { valueType: '数字含小数', unit: '%' },
        '单价': { valueType: '数字含小数', unit: '元' },
        '证书编号': { valueType: '数字及字母X', unit: '' },
        '交货地点': { valueType: '任意格式文本', unit: '' },
        '期限(服务/交货/工期)': { valueType: '任意格式文本', unit: '' },
        '其它': { valueType: '任意格式文本', unit: '' },
        '姓名': { valueType: '任意格式文本', unit: '' },
        '质量标准': { valueType: '任意格式文本', unit: '' }
      },

      // 表单验证规则
      rules: {
        bidInvitationDocumentsName: [
          { required: true, message: '请输入招标文件名称' }
        ],
        bidSection: [
          { required: true, message: '请选择标段' }
        ],
        deadline: [
          { required: true, message: '请选择开标/递交截止时间' }
        ],
        bidLimit: [
          { required: true, message: '请输入投标限价' },
          { validator: this.validateBidLimit, }
        ],
        decryptionDeadline: [
          { required: true, message: '请选择解密截止时间', },
          { validator: this.validateDecryptionDeadline, }
        ],
        questionDeadline: [
          { required: true, message: '选择质疑截止时间', }
        ],


      }
    }
  },
  computed: {
    isDoubleEnvelope() {
      const selectedSection = this.bidSectionList.find(item => item.bidSectionCode === this.form.bidSection)
      return selectedSection ? Number(selectedSection.isDoubleEnvelope || 0) === 1 : false
    },
    isBlindReviewEnabled() {
      return Number(this.isBlindReview) === 1
    },
    mainFiles() {
      return this.uploadedFiles.filter(f => f.tenderFileType === this.$tenderFileType.MAIN_FILE)
    },
    attFiles() {
      return this.uploadedFiles.filter(f => f.tenderFileType === this.$tenderFileType.ATTACHMENT)
    },
    currentOpeningSummaryData() {
      if (this.isDoubleEnvelope) {
        return this.activeEnvelopeTab === '2' ? this.openingSummaryDataEnvelope2 : this.openingSummaryData
      }
      return this.openingSummaryDataNormal
    },
    currentDirectoryTreeData() {
      if (this.isDoubleEnvelope) {
        return this.activeDirectoryEnvelopeTab === '2' ? this.directoryData.treeDataEnvelope2 : this.directoryData.treeData
      }
      return this.directoryData.treeData
    },
    currentBlindTreeData() {
      if (this.isDoubleEnvelope) {
        return this.activeDirectoryEnvelopeTab === '2' ? this.directoryData.blindTreeDataEnvelope2 : this.directoryData.blindTreeData
      }
      return this.directoryData.blindTreeData
    },
    hasPdfMain() {
      return this.mainFiles.some(f => f.fileType === 'pdf')
    },
    hasWordMain() {
      return this.mainFiles.some(f => f.fileType === 'doc' || f.fileType === 'docx')
    }
  },
  watch: {
    'form.bidSection'() {
      this.syncBlindReviewBySelectedSection()
      // 切换标段时重置信封Tab为第一个
      this.activeEnvelopeTab = '1'
      this.activeDirectoryEnvelopeTab = '1'
      // 如果是双信封模式且二信封数据为空，初始化默认数据
      if (this.isDoubleEnvelope && (!this.openingSummaryDataEnvelope2 || this.openingSummaryDataEnvelope2.length === 0)) {
        this.initEnvelope2DefaultData()
      }
    }
  },
  mounted() {
    this.initPage()

    if (this.$route.query.bidInvitationDocumentsCode) {
      this.getBidInvitationDocumentsDetail(this.$route.query.bidInvitationDocumentsCode)
      this.title = "编辑招标文件"
    } else {
      //   当前时间戳+ 5位随机数
      this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
    }
  },
  methods: {
    // 初始化二信封开标一览表默认数据
    initEnvelope2DefaultData() {
      this.openingSummaryDataEnvelope2 = [
        {
          name: '总价',
          valueType: '数字含小数',
          unit: '元',
          instructions: '',
          type: '总价',
          hide: 0
        },
        {
          name: '总价(大写)',
          valueType: '任意格式文本',
          unit: '元',
          instructions: '',
          type: '其它',
          hide: 0
        }
      ]
    },
    // 编辑的时候数据回显
    async getBidInvitationDocumentsDetail(bidInvitationDocumentsCode) {
      try {
        const res = await getBidInvitationDocumentsDetail({
          bidInvitationDocumentsCode: bidInvitationDocumentsCode
        })
        if (res.code === 200) {
          const data = res.data
          // 回显基本表单数据
          this.form.bidInvitationDocumentsName = data.bidInvitationDocumentsName || ''
          this.form.remark = data.remark || ''
          this.fileBindId = data.fileGuid;
          // this.form.projectName = data.projectName || ''
          this.getFileDownloadList(data.fileGuid)
          if (data.bidSectionList && data.bidSectionList.length > 0) {
            // 填充标段列表选项
            this.bidSectionList = data.bidSectionList.map(item => ({
              bidSectionCode: item.bidSectionCode,
              bidSectionName: item.bidSectionName,
              sectionId: item.sectionId,
              isBlindReview: Number(item.isBlindReview || 0),
              isDoubleEnvelope: Number(item.isDoubleEnvelope || 0)
            }))
            // 单选模式：回显第一个标段
            this.form.bidSection = data.bidSectionList[0]?.bidSectionCode || ''
          }


          // 回显时间相关字段（从 bidSectionConfig 中获取）
          if (data.bidSectionConfig) {
            this.form.deadline = data.bidSectionConfig.bidOpeningTime || data.bidOpeningTime || ''
            this.form.decryptionDeadline = data.bidSectionConfig.decryptionDeadline || data.decryptionDeadline || ''
            this.form.questionDeadline = data.bidSectionConfig.questionDeadline || ''

            // 回显招标控制价
            this.form.bidLimit = data.bidSectionConfig.tenderControlPrice || ''
            this.form.bidLimitType = data.bidSectionConfig.tenderControlPriceType || 1
            this.form.bidLimitUnit = data.bidSectionConfig.tenderControlPriceUnit || 0

            // 回显暗标设置
            this.isBlindReview = Number(data.bidSectionConfig.isBlindReview || 0)
          }

          // 回显开标一览表数据
          if (data.bidOpeningLists && data.bidOpeningLists.length > 0) {
            const mapItem = (item) => {
              // 映射 itemValueType: 0-任意格式文本, 1-数字含小数
              let valueType = '任意格式文本'
              if (item.itemValueType === 1) {
                valueType = '数字含小数'
              } else if (item.itemValueType === 0) {
                valueType = '任意格式文本'
              }

              // 映射 itemUnit: 0-元, 1-万元, 2-%
              let unit = ''
              if (item.itemUnit === 0) {
                unit = '元'
              } else if (item.itemUnit === 1) {
                unit = '万元'
              } else if (item.itemUnit === 2) {
                unit = '%'
              }

              // 映射 itemType 到 type 字段
              const typeMap = {
                '1': '总价',
                '2': '费率',
                '3': '单价',
                '4': '证书编号',
                '5': '交货地点',
                '6': '期限(服务/交货/工期)',
                '7': '姓名',
                '11': '质量标准',
                '9': '其它',
                '0': '其它'
              }

              return {
                name: item.itemName || '',
                valueType: valueType,
                unit: unit,
                instructions: item.itemInstructions || '',
                type: typeMap[String(item.itemType)] || '其它',
                id: item.id, // 保存原始ID，用于后续更新
                envelopeType: item.envelopeType || null, // 信封编号
                hide: item.hide || 0 // 是否隐藏总价（0：不隐藏，1：隐藏）
              }
            }
            // 按 envelopeType 拆分：旧数据（envelopeType 为空）全部归入一信封
            const envelope1Items = data.bidOpeningLists.filter(item => !item.envelopeType || Number(item.envelopeType) === 1)
            const envelope2Items = data.bidOpeningLists.filter(item => Number(item.envelopeType) === 2)
            this.openingSummaryData = envelope1Items.map(mapItem)
            // 非双信封模式：使用 openingSummaryDataNormal 接收回显
            this.openingSummaryDataNormal = envelope1Items.map(mapItem)
            if (envelope2Items.length > 0) {
              this.openingSummaryDataEnvelope2 = envelope2Items.map(mapItem)
            }
          }

          // 回显投标文件目录
          if (data.catalogues && data.catalogues.length > 0) {
            // 按信封拆分：旧数据（envelopeType 为空）归入一信封
            const envelope1Catalogues = data.catalogues.filter(item => !item.envelopeType || Number(item.envelopeType) === 1)
            const envelope2Catalogues = data.catalogues.filter(item => Number(item.envelopeType) === 2)
            const normalCatalogues = envelope1Catalogues.filter(item => Number(item.isBlindReview || 0) !== 1)
            const blindCatalogues = envelope1Catalogues.filter(item => Number(item.isBlindReview || 0) === 1)
            // 后端返回嵌套数据，使用 convertNestedCatalogues 保留层级
            this.directoryData.treeData = this.convertNestedCatalogues(normalCatalogues)
            this.directoryData.blindTreeData = this.convertNestedCatalogues(blindCatalogues)
            // 二信封目录
            if (envelope2Catalogues.length > 0) {
              const normalCatalogues2 = envelope2Catalogues.filter(item => Number(item.isBlindReview || 0) !== 1)
              const blindCatalogues2 = envelope2Catalogues.filter(item => Number(item.isBlindReview || 0) === 1)
              this.directoryData.treeDataEnvelope2 = this.convertNestedCatalogues(normalCatalogues2)
              this.directoryData.blindTreeDataEnvelope2 = this.convertNestedCatalogues(blindCatalogues2)
            }
          }

          this.$message.success('数据加载成功')
        } else {
          this.$message.error(res.msg || '获取招标文件详情失败')
        }
      } catch (error) {
        console.error('获取招标文件详情失败:', error)
        this.$message.error('获取招标文件详情失败，请重试')
      }
    },
    // 附件回显
    getFileDownloadList(fileGuid) {
      getFileList(fileGuid).then(res => {
        if (res.code === 200) {
          const fileList = res.data || []

          // 将接口返回的文件数据映射到 uploadedFiles
          this.uploadedFiles = fileList.map(file => {
            // fileType 使用小写扩展名，与新上传时保持一致（供 hasPdfMain/hasWordMain 计算）
            const ext = (file.fileExtension || file.fileName?.split('.').pop() || '').toLowerCase()
            const fileType = ext || '其他'

            // tenderFileType 来自接口返回的 fileType 字段（invitation-main / invitation-att）
            const tenderFileType = file.fileType || ''

            return {
              fileId: file.fileId,
              fileName: file.fileName,
              fileType: fileType,
              fileExtension: file.fileExtension,
              fileSize: file.fileSize,
              fileUrl: file.fileUrl,
              tenderFileType: tenderFileType,
              uploadTime: '-',
              uploader: '-'
            }
          })

          console.log('已上传文件列表:', this.uploadedFiles)
        } else {
          this.$message.error(res.msg || '获取文件列表失败')
        }
      }).catch(error => {
        console.error('获取文件列表失败:', error)
        this.$message.error('获取文件列表失败')
      })
    },




    // 构建目录树形结构（从扁平数据）
    buildDirectoryTree(catalogues) {
      // 将扁平数据转换为树形结构
      const map = {}
      const roots = []

      // 先创建所有节点的映射
      catalogues.forEach(item => {
        map[item.catalogueCode] = {
          id: item.id || item.strId,
          catalogueCode: item.catalogueCode,
          name: item.catalogueName,
          description: item.catalogueDescription,
          pageNum: item.pageNum,
          children: []
        }
      })

      // 建立父子关系
      catalogues.forEach(item => {
        const node = map[item.catalogueCode]
        if (item.catalogueParentCode === 0 || !item.catalogueParentCode) {
          // 根节点
          roots.push(node)
        } else {
          // 子节点
          const parent = map[item.catalogueParentCode]
          if (parent) {
            parent.children.push(node)
          }
        }
      })

      return roots
    },

    // 转换后端嵌套的目录数据为前端格式（后端已包含children层级）
    convertNestedCatalogues(catalogues) {
      if (!Array.isArray(catalogues)) return []
      return catalogues.map(item => ({
        id: item.id || item.strId,
        catalogueCode: item.catalogueCode,
        name: item.catalogueName,
        description: item.catalogueDescription,
        pageNum: item.pageNum,
        children: Array.isArray(item.children) && item.children.length > 0
          ? this.convertNestedCatalogues(item.children)
          : []
      }))
    },

    //初始化页面
    initPage() {
      const projectCode = this.$route.query.projectCode
      if (!projectCode) {
        this.$message.error('缺少项目编号参数')
        this.$router.go(-1)
        return
      }
      this.projectCode = projectCode
      this.loadProjectDetail()
      if (!this.$route.query.bidInvitationDocumentsCode) {
        this.loadBidSectionList()
      }

    },
    //加载项目详情
    async loadProjectDetail() {
      try {
        const res = await getProjectDetail({ projectCode: this.projectCode })
        if (res.code === 200) {
          this.projectDetail = res.data
          this.pageTitle = this.generatePageTitle(res.data)
          this.form.projectName = res.data.projectName
        } else {
          this.$handleApiError(res, '获取项目详情失败', this)
        }
      } catch (error) {
        this.$handleError(error, '获取项目详情失败', this)
      }
    },

    //加载标段列表
    async loadBidSectionList() {
      this.loading = true
      try {
        const res = await initBidInvitationDocumentsData({ projectCode: this.projectCode })
        if (res.code === 200) {
          console.log('初始化标书文件数据:', res.data)
          let arr = [];
          for (let index = 0; index < res.data.bidSectionList.length; index++) {
            const element = res.data.bidSectionList[index];
            if (element.isSelected < 1) {
              arr.push({
                ...element,
                isBlindReview: Number(element.isBlindReview || 0),
                isDoubleEnvelope: Number(element.isDoubleEnvelope || 0)
              })

            }

          }

          this.bidSectionList = arr || []
          this.syncBlindReviewBySelectedSection()

        } else {
          this.$handleApiError(res, '获取标段列表失败', this)
        }
      } catch (error) {
        this.$handleError(error, '获取标段列表失败', this)
      } finally {
        this.loading = false
      }
    },


    //生成页面标题
    generatePageTitle(projectData) {
      const projectTypeName = getProjectTypeName(projectData.projectType)
      return `${projectTypeName}--招标项目编号：${projectData.projectCode}　招标项目名称：${projectData.projectName}`
    },

    syncBlindReviewBySelectedSection() {
      const selectedBidSection = this.bidSectionList.find(item => item.bidSectionCode === this.form.bidSection)
      this.isBlindReview = selectedBidSection ? Number(selectedBidSection.isBlindReview || 0) : 0
    },
    //提交表单
    handleSubmit(status) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 校验必须上传 PDF 和 Word 文件
          if (!this.validateTenderFiles()) {
            return
          }
          if (this.uploadedFiles.length <= 0) {
            this.$message.error('请上传附件')
            return
          }
          this.submitBidFile(status)
        } else {
          this.$message.error('请完善必填信息')
        }
      })
    },

    // 校验招标文件（必须包含招标文件正文 PDF 和 Word 各 1 份）
    validateTenderFiles() {
      const hasPdf = this.mainFiles.some(f => f.fileType === 'pdf')
      // const hasWord = this.mainFiles.some(f => f.fileType === 'doc' || f.fileType === 'docx')

      if (!hasPdf) {
        this.$message.error('请上传招标文件正文的 PDF')
        return false
      }
      if (!hasPdf) {
        this.$message.error('请上传招标文件正文的 PDF 文件')
        return false
      }
      // if (!hasWord) {
      //   this.$message.error('请上传招标文件正文的 Word 文件')
      //   return false
      // }
      return true
    },

    //提交招标文件数据
    async submitBidFile(status) {
      const formData = this.prepareFormData(status)
      formData.fileGuid = this.fileBindId
      formData.documentType = 1,
        formData.documentPreparationStatus = status;
      this.operationStatus.isSubmitting = true
      try {
        const res = await addBidInvitationDocuments(formData)
        if (res.code === 200) {
          this.$message.success(status === 1 ? '提交成功' : '暂存成功')
          this.handleBack()
        } else {
          this.$handleApiError(res, '操作失败', this)
        }
      } catch (error) {
        this.$handleError(error, '操作失败', this)
      } finally {
        this.operationStatus.isSubmitting = false
      }
    },

    //准备表单数据
    prepareFormData(status) {
      // 类型
      const typeMapping = {
        '总价': '1',
        '费率': '2',
        '单价': '3',
        '其它': '0',
        '证书编号': '4',
        '交货地点': '5',
        '期限(服务/交货/工期)': '6',
        '姓名': '7',
        // '身份证号': '8',
        '质量标准': '11'
      }

      // 单位
      const unitMapping = {
        '元': 0,
        '万元': 1,
        '%': 2
      }

      // 数值类
      const valueTypeMapping = {
        '任意格式文本': 0,
        '数字含小数': 1,
        '数字及字母X': 1
      }

      // 组装开标一览表数据
      const buildOpeningList = (dataArr, envelopeType) => {
        return dataArr.map((item, index) => {
          return {
            itemInstructions: item.instructions || '', // 填报说明
            itemKey: index + 1, // key，序号
            itemName: item.name, // 名称
            itemType: typeMapping[item.type] || '0', // 类型映射
            itemUnit: unitMapping[item.unit], // 单位映射
            itemValueType: valueTypeMapping[item.valueType] || 0, // 填报内容类型
            status: status.toString(), // 状态，0：暂存，1：提交
            envelopeType: envelopeType, // 信封编号（1：一信封，2：二信封，null：非双信封）
            hide: item.hide || 0 // 是否隐藏总价（0：不隐藏，1：隐藏）
          }
        })
      }
      // 非双信封模式：使用 openingSummaryDataNormal（总价、总价(大写)、工期、质量标准）
      // 双信封模式：使用 openingSummaryData（一信封）和 openingSummaryDataEnvelope2（二信封）
      let bidOpeningLists
      if (this.isDoubleEnvelope) {
        bidOpeningLists = buildOpeningList(this.openingSummaryData, 1)
        bidOpeningLists = bidOpeningLists.concat(buildOpeningList(this.openingSummaryDataEnvelope2, 2))
      } else {
        bidOpeningLists = buildOpeningList(this.openingSummaryDataNormal, null)
      }
      let bidSections;
      if (!this.$route.query.bidInvitationDocumentsCode) {
        bidSections = this.prepareBidSections()
      } else {


        bidSections = this.bidSectionList;
      }



      let formData = {
        // 标段相关配置
        bidSectionConfig: {
          bidOpeningTime: timeUtils.formatTime(this.form.deadline), // 开标时间，确保格式正确
          isBlindReview: Number(this.isBlindReview || 0), // 暗标评审（0：明标、1：暗标）
          tenderControlPrice: Number(this.form.bidLimit), // 招标控制价（投标限价）
          tenderControlPriceType: this.form.bidLimitType, // 招标控制价类型（1：金额、2：费率）
          tenderControlPriceUnit: this.form.bidLimitUnit, // 招标控制价单位（0：元，1：万元）
          decryptionDeadline: timeUtils.formatTime(this.form.decryptionDeadline), // 解密截止时间，确保格式正确
          questionDeadline: timeUtils.formatTime(this.form.questionDeadline)

        },
        // 开标一览表
        bidOpeningLists: bidOpeningLists,
        bidSections: bidSections, // 标段列表
        catalogues: this.buildCataloguesTree(),
        projectCode: this.projectCode, // 项目编号
        projectId: this.projectDetail.id, // 项目id
        bidInvitationDocumentsName: this.form.bidInvitationDocumentsName, // 招标文件名称
        remark: this.form.remark || '',
        status: status.toString() // 状态，0：暂存，1：提交
      }
      if (this.$route.query.bidInvitationDocumentsCode) {
        formData.bidInvitationDocumentsCode = this.$route.query.bidInvitationDocumentsCode

      }
      return formData
    },

    // 构建提交给后端的目录树 catalogues
    buildCataloguesTree() {
      // 生成时间与一些公共字段
      const createTime = timeUtils.formatTime(new Date())
      // 多选标段模式：目录树中的 bidSectionCode 置空，由后端根据 bidSections 数组处理标段关联
      let autoIncrementCode = 1
      const makeNode = (node, parentCode, order, isBlindReview = 0, envelopeType = null) => {
        const catalogueCode = autoIncrementCode++ // 自增目录编号
        const mapped = {
          isBlindReview: isBlindReview,
          envelopeType: envelopeType, // 信封编号（1：一信封，2：二信封，null：非双信封）
          idInvitationDocumentsCode: '', // 新增时通常由后端生成，先置空
          bidSectionCode: '', // 多选标段模式下置空，由后端根据 bidSections 数组处理
          catalogueCode: catalogueCode, // 目录编号（整数）
          catalogueDescription: node.name, // 要求等于 catalogueName
          catalogueName: node.name, // 目录名称
          catalogueOrder: typeof order === 'number' ? order : 0, // 排序（整数）
          catalogueParentCode: parentCode || 0, // 上级目录编号（根目录给 0）
          children: [], // 下级目录数组
          createTime: createTime, // 创建时间
          // id: node.id // 使用前端节点 id 传递
        }
        if (Array.isArray(node.children) && node.children.length > 0) {
          mapped.children = node.children.map((child, index) =>
            makeNode(child, catalogueCode, index + 1, isBlindReview, envelopeType)
          )
        }
        return mapped
      }
      const envelope1 = this.isDoubleEnvelope ? 1 : null
      const envelope2 = this.isDoubleEnvelope ? 2 : null
      const normalCatalogues = Array.isArray(this.directoryData.treeData)
        ? this.directoryData.treeData.map((root, index) => makeNode(root, 0, index + 1, 0, envelope1))
        : []
      // 双信封二信封普通目录
      const normalCataloguesEnvelope2 = (this.isDoubleEnvelope && Array.isArray(this.directoryData.treeDataEnvelope2))
        ? this.directoryData.treeDataEnvelope2.map((root, index) => makeNode(root, 0, index + 1, 0, envelope2))
        : []
      if (!this.isBlindReviewEnabled) {
        return [...normalCatalogues, ...normalCataloguesEnvelope2]
      }
      const blindCatalogues = Array.isArray(this.directoryData.blindTreeData)
        ? this.directoryData.blindTreeData.map((root, index) => makeNode(root, 0, index + 1, 1, envelope1))
        : []
      // 双信封二信封暗标目录
      const blindCataloguesEnvelope2 = (this.isDoubleEnvelope && Array.isArray(this.directoryData.blindTreeDataEnvelope2))
        ? this.directoryData.blindTreeDataEnvelope2.map((root, index) => makeNode(root, 0, index + 1, 1, envelope2))
        : []
      return [...normalCatalogues, ...normalCataloguesEnvelope2, ...blindCatalogues, ...blindCataloguesEnvelope2]
    },

    //准备标段数据
    prepareBidSections() {
      const bidSections = []
      // 单选模式：根据选中的标段编码查找标段对象
      if (this.form.bidSection) {
        const selectedBidSection = this.bidSectionList.find(item => item.bidSectionCode === this.form.bidSection)
        if (selectedBidSection) {
          bidSections.push(selectedBidSection)
        }
      }
      return bidSections
    },

    //自定义招标控制价校验
    validateBidLimit(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入招标控制价'))
      } else if (!/^[0-9]+(\.[0-9]+)?$/.test(value)) {
        callback(new Error('请输入有效的数字'))
      } else {
        callback()
      }
    },

    //自定义解密截止时间校验
    validateDecryptionDeadline(rule, value, callback) {
      if (!this.form.deadline) {
        callback(new Error('请先选择开标/递交截止时间'))
      } else if (!value) {
        callback(new Error('请选择解密截止时间'))
      } else if (!timeUtils.isValidTimeFormat(value)) {
        callback(new Error('时间格式不正确'))
      } else {
        // 检查解密截止时间是否晚于开标时间
        if (this.form.deadline && timeUtils.compareTime(value, this.form.deadline) <= 0) {
          callback(new Error('解密截止时间必须晚于开标时间'))
        } else {
          callback()
        }
      }
    },

    //处理类型切换
    handleTypeChange() {
      // 切换类型时，如果是费率，重置单位
      if (this.form.bidLimitType === 2) {
        this.form.bidLimitUnit = 0
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate('bidLimit')
      })
    },
    //处理单位切换，阻止触发表单验证
    handleUnitChange() {
      this.$nextTick(() => {
        this.$refs.form.clearValidate('bidLimit')
      })
    },

    //处理开标时间变化
    handleDeadlineChange() {
      if (!this.form.deadline) {
        this.form.decryptionDeadline = ''
        return
      }

      const deadlineDate = new Date(this.form.deadline.replace(/-/g, '/'))
      if (!Number.isNaN(deadlineDate.getTime())) {
        const decryptionDate = new Date(deadlineDate.getTime() + 30 * 60 * 1000)
        this.form.decryptionDeadline = timeUtils.formatTime(decryptionDate)
      }

      // 如果解密截止时间已设置，需要重新验证
      if (this.form.decryptionDeadline) {
        this.$nextTick(() => {
          this.$refs.form.validateField('decryptionDeadline')
        })
      }
    },

    //处理解密截止时间变化
    handleDecryptionDeadlineChange() {
      // 如果开标时间已设置，需要重新验证
      if (this.form.deadline) {
        this.$nextTick(() => {
          this.$refs.form.validateField('deadline')
        })
      }
    },

    //返回上一页
    handleBack() {
      this.$router.go(-1)
    },

    //文件上传
    handleUpload(type, fileType) {
      // 保存文件类型标识，用于后续上传
      this.tenderFileType = fileType
      // 创建文件输入框，type 用于限制文件类型
      this.createFileInput(type, fileType)
    },

    //创建文件输入框
    createFileInput(type, fileType) {
      // 根据 type 设置 accept 属性，限制文件上传类型
      let acceptTypes = ''
      if (type === 'word') {
        acceptTypes = '.doc,.docx'
      } else if (type === 'pdf') {
        acceptTypes = '.pdf'
      } else if (type === 'attachment') {
        acceptTypes = this.uploadConstants.SUPPORTED_FILE_TYPES
      } else {
        acceptTypes = this.uploadConstants.SUPPORTED_FILE_TYPES
      }

      const input = document.createElement('input')
      input.type = 'file'
      input.accept = acceptTypes
      input.onchange = (e) => {
        this.handleFileSelect(e, type, fileType)
      }
      input.click()
    },

    // 处理文件选择
    async handleFileSelect(event, type, fileType) {
      const file = event.target.files[0]
      if (!file || !this.validateFile(file, type)) return

      try {
        this.showUploadProgress(file)
        // fileType 作为上传时的入参传递
        const uploadResult = await this.uploadFileWithChunks(file, fileType)
        this.handleUploadResult(uploadResult, file, type, fileType)
      } catch (error) {
        this.handleUploadError(error, file)
      }
    },

    //验证文件
    validateFile(file, type) {
      const maxSize = 102400 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10GB')
        return false
      }
      // 根据 type 验证文件扩展名
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
      let allowedTypes = []
      if (type === 'word') {
        allowedTypes = ['.doc', '.docx']
      } else if (type === 'pdf') {
        allowedTypes = ['.pdf']
      } else if (type === 'attachment') {
        allowedTypes = this.uploadConstants.SUPPORTED_FILE_TYPES.split(',')
      } else {
        allowedTypes = this.uploadConstants.SUPPORTED_FILE_TYPES.split(',')
      }
      if (!allowedTypes.includes(fileExtension)) {
        const typeName = type === 'word' ? 'Word' : type === 'pdf' ? 'PDF' : '附件'
        this.$message.error(`请上传${typeName}格式的文件`)
        return false
      }
      return true
    },

    //显示上传进度
    showUploadProgress(file) {
      const now = Date.now()
      this.uploadProgress = {
        visible: true,
        percentage: 0,
        fileName: file.name,
        fileSize: file.size || 0,
        loaded: 0,
        speed: 0,
        speedText: '',
        startTime: now,
        lastUpdateTime: now,
        lastLoaded: 0,
        status: this.uploadConstants.UPLOAD_STATUS.UPLOADING
      }
    },

    //上传文件（分块上传）
    async uploadFileWithChunks(file, fileType) {
      file.fileType = fileType
      let uploadedFileId = null
      const uploadResult = await doFileUpload(file, {
        fileBindId: this.fileBindId,
        onProgress: (progress, task) => {
          this.handleUploadProgressUpdate(progress, task, file)
        },
        onSuccess: (r) => {
          uploadedFileId = r.fileId || r.id || ''
        },
        onError: () => {
        }
      })
      if (uploadResult && uploadedFileId) {
        uploadResult.fileId = uploadedFileId
      }
      return uploadResult
    },

    //处理上传进度更新（计算已上传字节与上传速度）
    handleUploadProgressUpdate(progress, task, file) {
      const pct = Math.round(Number(progress) || 0)
      const now = Date.now()
      // 计算已上传字节数
      let loaded = 0
      let total = this.uploadProgress.fileSize || (file && file.size) || 0

      if (task && (task.totalChunks || task.file)) {
        // 分片上传模式：依据分片进度计算
        total = (task.file && task.file.size) || total
        const totalChunks = task.totalChunks || task.chunks?.length || 1
        const uploadedChunks = task.uploadedChunks || 0
        loaded = Math.round((uploadedChunks / totalChunks) * total)
      } else {
        // 单文件上传模式：依据百分比推算
        loaded = Math.round((pct / 100) * total)
      }

      // 计算瞬时上传速度（字节/秒），并使用指数加权平均进行平滑，避免抖动
      const timeDelta = (now - (this.uploadProgress.lastUpdateTime || now)) / 1000
      const loadedDelta = loaded - (this.uploadProgress.lastLoaded || 0)
      if (timeDelta > 0 && loadedDelta >= 0) {
        const instantSpeed = loadedDelta / timeDelta
        this.uploadProgress.speed = this.uploadProgress.speed > 0
          ? this.uploadProgress.speed * 0.7 + instantSpeed * 0.3
          : instantSpeed
        this.uploadProgress.speedText = this.formatUploadSpeed(this.uploadProgress.speed)
      } else if (!this.uploadProgress.speedText) {
        this.uploadProgress.speedText = ''
      }

      this.uploadProgress.percentage = pct
      this.uploadProgress.loaded = loaded
      if (total > 0) {
        this.uploadProgress.fileSize = total
      }
      this.uploadProgress.lastUpdateTime = now
      this.uploadProgress.lastLoaded = loaded
    },

    //格式化上传速度
    formatUploadSpeed(bytesPerSec) {
      if (!bytesPerSec || bytesPerSec <= 0) return '0 B/s'
      if (bytesPerSec < 1024) return bytesPerSec.toFixed(0) + ' B/s'
      if (bytesPerSec < 1024 * 1024) return (bytesPerSec / 1024).toFixed(1) + ' KB/s'
      return (bytesPerSec / 1024 / 1024).toFixed(2) + ' MB/s'
    },

    //处理上传结果
    handleUploadResult(uploadResult, file, type, fileType) {
      if (uploadResult && uploadResult.success) {
        this.uploadProgress.status = this.uploadConstants.UPLOAD_STATUS.SUCCESS
        this.uploadProgress.percentage = 100
        const fileId = uploadResult.fileId || uploadResult.id || ''
        if (fileId) {
          this.uploadedFiles.push({
            fileName: file.name,
            fileType: this.getFileTypeLabel(type, file.name),
            fileSize: file.size || 0,
            uploadTime: new Date().toLocaleString(),
            uploader: '当前用户',
            fileId: fileId,
            fileTypeCode: fileType, // 保存文件类型标识，用于上传时的入参
            tenderFileType: this.tenderFileType // 保存文件类型标识
          })
        }
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.success(`文件 ${file.name} 上传成功`)
        }, 1000)
      } else {
        this.uploadProgress.status = this.uploadConstants.UPLOAD_STATUS.ERROR
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.error(`文件上传失败: ${uploadResult?.message || '未知错误'}`)
        }, 1000)
      }
    },

    //处理上传错误
    handleUploadError(error, file) {
      this.uploadProgress.status = this.uploadConstants.UPLOAD_STATUS.ERROR
      setTimeout(() => {
        this.uploadProgress.visible = false
        this.$message.error(`文件上传失败: ${error.message || '未知错误'}`)
      }, 1000)
    },

    //格式化文件大小
    formatFileSize(bytes) {
      if (!bytes && bytes !== 0) return '-'
      if (bytes === 0) return '0 KB'
      const kb = bytes / 1024
      return kb < 1 ? '< 1 KB' : kb.toFixed(1) + ' KB'
    },

    //获取文件类型标签
    getFileTypeLabel(fileType, fileName) {
      if (fileName) {
        const ext = fileName.split('.').pop()
        if (ext && ext !== fileName) return ext.toLowerCase()
      }
      const typeMap = {
        'word': 'word',
        'pdf': 'pdf',
        'attachment': '附件'
      }
      return typeMap[fileType] || '其他'
    },

    //删除文件
    handleDeleteFile(row) {
      this.deleteAndDecryptAtt(row)
    },
    deleteAndDecryptAtt(row) {
      this.$confirm(`确定要删除附件 "${row.fileName}" 吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteBidAtt(row.fileId)
          if (res.code === 200) {
            const index = this.uploadedFiles.findIndex(item => item.fileId === row.fileId)
            if (index > -1) {
              this.uploadedFiles.splice(index, 1)
              this.$message.success('删除成功')
            }
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除附件失败:', error)
          this.$message.error('删除失败：' + (error.message || '未知错误'))
        }
      }).catch(() => {
        // 用户取消删除
      })
    },


    //编辑开标内容项
    editSummaryItem(index) {
      const data = this.currentOpeningSummaryData
      const item = data[index]
      // 保存原始数据，用于取消编辑时恢复
      this.$set(data, index, {
        ...item,
        isEditing: true,
        _originalData: {
          name: item.name,
          unit: item.unit,
          instructions: item.instructions
        }
      })
    },

    //取消编辑开标内容项
    cancelEditSummaryItem(index) {
      const data = this.currentOpeningSummaryData
      const item = data[index]
      // 恢复原始数据
      if (item._originalData) {
        this.$set(data, index, {
          ...item,
          name: item._originalData.name,
          unit: item._originalData.unit,
          instructions: item._originalData.instructions,
          isEditing: false,
          _originalData: undefined
        })
      }
    },

    //保存开标内容项
    saveSummaryItem(index) {
      const data = this.currentOpeningSummaryData
      const item = data[index]
      // if (!item.name || !item.valueType || !item.unit || !item.instructions) {
      //     this.$message.error('请填写完整信息')
      //     return
      // }
      // 移除 isNew 和 isEditing 标记，变为只读状态
      this.$set(data, index, {
        ...item,
        isNew: false,
        isEditing: false,
        _originalData: undefined
      })
      this.$message.success('保存成功')
    },

    //上移/下移开标内容项
    moveSummaryItem(index, direction) {
      const targetIndex = direction === 'up' ? index - 1 : index + 1
      const data = this.currentOpeningSummaryData
      const temp = data[index]
      this.$set(data, index, data[targetIndex])
      this.$set(data, targetIndex, temp)
    },

    //删除开标内容项
    deleteSummaryItem(index) {
      this.currentOpeningSummaryData.splice(index, 1)
      this.$message.success('删除成功')
    },

    // 切换总价隐藏状态（眼睛图标）
    togglehide(index) {
      const data = this.currentOpeningSummaryData
      // 只允许操作总价行（index 0）
      if (data[index].type !== '总价') return
      const newhide = data[index].hide === 1 ? 0 : 1
      // 切换总价行的 hide
      data[index].hide = newhide
      // 总价大写行自动同步：隐藏总价时也隐藏总价大写
      const totalCapitalRow = data.find(item => item.name === '总价(大写)')
      if (totalCapitalRow) {
        totalCapitalRow.hide = newhide
      }
    },

    //显示添加弹窗
    showAddDialog() {
      this.dialogs.add = true
      this.addDialogData.selectedType = ''
    },

    //确认添加
    confirmAdd() {
      // if (!this.addDialogData.selectedType) {
      //     this.$message.error('请选择自定义内容的类型')
      //     return
      // }

      // // 根据选择的类型添加新数据
      // const config = this.typeConfig[this.addDialogData.selectedType]
      // const newItem = {
      //     name: this.addDialogData.selectedType,
      //     valueType: config.valueType,
      //     unit: config.unit,
      //     instructions: '',
      //     type: this.addDialogData.selectedType,
      //     isNew: true
      // }

      // this.openingSummaryData.push(newItem)
      // this.dialogs.add = false
      // this.addDialogData.selectedType = ''
      // this.$message.success('添加成功')


      if (!this.addDialogData.selectedType) {
        this.$message.error('请选择自定义内容的类型')
        return
      }

      const selectedType = this.addDialogData.selectedType

      const config = this.typeConfig[selectedType]

      // 添加原有的项
      const newItem = {
        name: selectedType,
        valueType: config.valueType,
        unit: config.unit,
        instructions: '',
        type: selectedType,
        isNew: true,
        envelopeType: this.isDoubleEnvelope ? Number(this.activeEnvelopeTab) : null
      }
      this.currentOpeningSummaryData.push(newItem)

      // 如果选择的是"单价"，额外添加"单价（大写）"
      if (selectedType === '单价') {
        const capitalItem = {
          name: '单价（大写）',
          valueType: '任意格式文本',
          unit: '元',
          instructions: '',
          type: '其他',
          isNew: true,
          envelopeType: this.isDoubleEnvelope ? Number(this.activeEnvelopeTab) : null
        }
        this.currentOpeningSummaryData.push(capitalItem)
      }

      this.dialogs.add = false
      this.addDialogData.selectedType = ''

    },

    //取消添加
    cancelAdd() {
      this.dialogs.add = false
      this.addDialogData.selectedType = ''
    },

    //加载引用文件数据
    loadReferenceData() {
      this.referenceData.loading = true
      setTimeout(() => {
        this.referenceData.loading = false
      }, 500)
    },

    //选择引用文件
    handleSelectReference(row) {
      this.form.referenceFile = row.fileName
      this.$message.success(`已选择引用文件: ${row.fileName}`)
      this.dialogs.reference = false
    },

    //取消选择引用文件
    handleCancelReference() {
      this.dialogs.reference = false
    },

    //引用文件分页大小改变
    handleReferenceSizeChange(val) {
      this.referenceData.pagination.pageSize = val
      this.loadReferenceData()
    },

    //引用文件当前页改变
    handleReferenceCurrentChange(val) {
      this.referenceData.pagination.currentPage = val
      this.loadReferenceData()
    },

    //显示目录管理弹窗
    showDirectoryDialog() {
      this.dialogs.directory = true
      // 如果目录数据为空，初始化一个空数组
      if (this.currentDirectoryTreeData.length === 0) {
        // 根据当前信封初始化正确的treeData
        if (this.isDoubleEnvelope) {
          if (this.activeDirectoryEnvelopeTab === '2') {
            this.directoryData.treeDataEnvelope2 = []
          } else {
            this.directoryData.treeData = []
          }
        } else {
          this.directoryData.treeData = []
        }
      }
      if (this.isBlindReviewEnabled && this.currentBlindTreeData.length === 0) {
        if (this.isDoubleEnvelope) {
          if (this.activeDirectoryEnvelopeTab === '2') {
            this.directoryData.blindTreeDataEnvelope2 = []
          } else {
            this.directoryData.blindTreeData = []
          }
        } else {
          this.directoryData.blindTreeData = []
        }
      }
    },

    //添加根目录
    addRootDirectory(target = 'normal') {
      const newDirectory = {
        id: Date.now(),
        name: '新建目录',
        children: []
      }
      if (this.isBlindReviewEnabled && target === 'blind') {
        this.currentBlindTreeData.push(newDirectory)
      } else {
        this.currentDirectoryTreeData.push(newDirectory)
      }
      // 自动进入编辑状态
      this.$nextTick(() => {
        this.editDirectoryName(newDirectory)
      })
    },

    //添加子目录
    addChildDirectory(parent) {
      if (!parent.children) {
        this.$set(parent, 'children', [])
      }
      const newChild = {
        id: Date.now() + Math.random(),
        name: '新建子目录',
        children: []
      }
      parent.children.push(newChild)
      // 自动进入编辑状态
      this.$nextTick(() => {
        this.editDirectoryName(newChild)
      })
    },

    //编辑目录名称
    editDirectoryName(node) {
      this.directoryData.editingNode = node
      this.directoryData.editingName = node.name
      // 聚焦输入框
      this.$nextTick(() => {
        const inputs = this.$refs.directoryInput
        if (inputs) {
          const inputArray = Array.isArray(inputs) ? inputs : [inputs]
          const currentInput = inputArray.find(inp => {
            if (inp && inp.$el) {
              const inputEl = inp.$el.querySelector('input')
              return inputEl && inputEl.value === node.name
            }
            return false
          })
          if (currentInput && currentInput.$el) {
            const inputEl = currentInput.$el.querySelector('input')
            if (inputEl) {
              inputEl.focus()
              inputEl.select()
            }
          } else if (inputArray.length > 0 && inputArray[0].$el) {
            // 如果找不到匹配的，就聚焦第一个
            const inputEl = inputArray[0].$el.querySelector('input')
            if (inputEl) {
              inputEl.focus()
              inputEl.select()
            }
          }
        }
      })
    },

    //保存目录名称
    saveDirectoryName(node) {
      if (!this.directoryData.editingName || this.directoryData.editingName.trim() === '') {
        this.$message.warning('目录名称不能为空')
        // 如果名称为空，恢复原名称
        this.directoryData.editingName = node.name
        return
      }
      node.name = this.directoryData.editingName.trim()
      this.directoryData.editingNode = null
      this.directoryData.editingName = ''
    },

    //删除目录
    deleteDirectory(node, index) {
      this.currentDirectoryTreeData.splice(index, 1)
      this.$message.success('删除成功')
    },
    deleteBlindDirectory(node, index) {
      this.currentBlindTreeData.splice(index, 1)
      this.$message.success('删除成功')
    },

    //删除子目录
    deleteChildDirectory(parent, child, childIndex) {
      this.$confirm('确定要删除该子目录及其所有子目录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (parent && parent.children) {
          parent.children.splice(childIndex, 1)
          this.$message.success('删除成功')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    //删除三级子目录
    deleteGrandchildDirectory(parent, grandchild, grandchildIndex) {
      this.$confirm('确定要删除该目录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (parent && parent.children) {
          parent.children.splice(grandchildIndex, 1)
          this.$message.success('删除成功')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    //确认目录设置
    confirmDirectory() {
      // 检查是否有正在编辑的目录
      if (this.directoryData.editingNode) {
        this.saveDirectoryName(this.directoryData.editingNode)
      }
      // 这里可以保存目录数据到表单或发送到后端
      console.log('目录数据:', JSON.stringify(this.currentDirectoryTreeData, null, 2))
      this.$message.success('目录设置已保存')
      this.dialogs.directory = false
    },

    // 打开粘贴目录弹窗
    openPasteDirectoryDialog(target = 'normal') {
      this.directoryData.pasteTarget = target
      this.dialogs.pasteDirectory = true
    },

    // 取消粘贴目录
    cancelPasteDirectory() {
      this.dialogs.pasteDirectory = false
    },

    // 确认粘贴目录并生成树
    confirmPasteDirectory() {
      const content = String(this.directoryData.pasteContent || '').trim()
      if (!content) {
        this.$message.warning('请先粘贴目录内容')
        return
      }

      const parsedTree = this.parseDirectoryText(content)
      if (!parsedTree.length) {
        this.$message.warning('未识别到有效目录，请检查格式')
        return
      }

      if (this.isBlindReviewEnabled && this.directoryData.pasteTarget === 'blind') {
        // 暗标目录始终使用 blindTreeData（当前信封的）
        if (this.isDoubleEnvelope && this.activeDirectoryEnvelopeTab === '2') {
          this.directoryData.blindTreeDataEnvelope2 = parsedTree
        } else {
          this.directoryData.blindTreeData = parsedTree
        }
      } else {
        if (this.isDoubleEnvelope && this.activeDirectoryEnvelopeTab === '2') {
          this.directoryData.treeDataEnvelope2 = parsedTree
        } else {
          this.directoryData.treeData = parsedTree
        }
      }
      this.dialogs.pasteDirectory = false
      this.$message.success('目录生成成功')
    },

    // 解析粘贴的目录文本
    parseDirectoryText(text) {
      const lines = text
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(Boolean)

      const roots = []
      let currentRoot = null

      const createNode = (name) => ({
        id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        name,
        children: []
      })

      lines.forEach((line) => {
        const isLevel1 = /^[一二三四五六七八九十百千万零〇两]+[、.．)）]/.test(line)
        const isLevel2 = /^\d+[、.．)）]/.test(line) || /^[（(]\d+[）)]/.test(line)

        if (!line) return

        if (isLevel1 || !currentRoot) {
          const rootNode = createNode(line)
          roots.push(rootNode)
          currentRoot = rootNode
          return
        }

        if (isLevel2 && currentRoot) {
          currentRoot.children.push(createNode(line))
          return
        }

        const rootNode = createNode(line)
        roots.push(rootNode)
        currentRoot = rootNode
      })

      return roots
    },

    //取消目录设置
    cancelDirectory() {
      // 如果有正在编辑的目录，取消编辑
      if (this.directoryData.editingNode) {
        this.directoryData.editingNode = null
        this.directoryData.editingName = ''
      }
      this.dialogs.directory = false
    }
  }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

.agent-page {
  .apply-minimal-gray-theme();
}

// ============================================
// 页面基础样式
// ============================================
.content-wrap {
  width: 100%;
  background: #fff;
  padding: 30px;
  border-radius: 4px;
  margin-top: 20px;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  box-shadow: @shadow-sm;
}

// ============================================
// 表单样式
// ============================================
.bid-form {
  .form-row {
    display: flex;
    gap: 40px;
    text-align: start;
  }

  .form-column {
    flex: 1;
  }

  .el-form-item {
    margin-bottom: 20px;

    .el-form-item__label {
      color: @gray-700;
      font-weight: 500;
    }
  }

  .el-input__inner,
  .el-textarea__inner {
    border-color: @gray-300;
    color: @gray-700;

    &:focus {
      border-color: @primary-color;
    }

    &::placeholder {
      color: @gray-400;
    }

    &:disabled {
      background-color: @gray-100;
      color: @gray-500;
    }
  }

  .upload-tip {
    color: @error-color;
    font-size: 12px;
    margin: 0 5px;
  }

  .upload-section {
    width: 100%;

    .upload-buttons {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
    }

    .uploaded-files-list {
      margin-top: 15px;

      .file-group {
        margin-top: 16px;

        &:first-child {
          margin-top: 12px;
        }

        .file-group-header {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          font-weight: 600;
          color: @gray-700;
          margin-bottom: 8px;
          padding: 6px 10px;
          background: @gray-100;
          border-radius: 4px;

          i {
            font-size: 14px;
            color: @primary-color;
          }
        }
      }

      .el-table {
        font-size: 13px;
        border: 1px solid @gray-200;
        border-radius: 4px;

        /deep/ .el-table__header {
          th {
            background-color: @gray-100;
            color: @gray-700;
            font-weight: 600;
          }
        }
      }
    }
  }
}

// ============================================
// 开标一览表样式
// ============================================
.opening-summary {
  margin-bottom: 30px;

  .summary-title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-700;
    margin-bottom: 15px;
    padding-left: 10px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 16px;
      background: @gray-700;
      border-radius: 2px;
    }
  }

  .add-summary-btn {
    margin-top: 25px;
    text-align: center;
  }

  .el-table {
    border: 1px solid @gray-200;
    border-radius: 4px;

    /deep/ .el-table__header {
      th {
        background-color: @gray-100;
        color: @gray-700;
        font-weight: 600;
      }
    }

    /deep/ .el-table__body {
      tr:hover {
        background-color: @gray-50;
      }
    }
  }

  .el-button--text {
    padding: 0;
    margin: 0 5px;
    color: @primary-color;

    &:hover {
      color: @primary-hover;
    }

    i {
      font-size: 16px;
    }
  }
}

// ============================================
// 复选框和单选框样式
// ============================================
.el-radio-group {
  .el-radio {
    margin-right: 20px;

    .el-radio__label {
      font-size: 14px;
      color: @gray-600;
    }

    .el-radio__input {
      &.is-checked .el-radio__inner {
        border-color: @primary-color;
        background: @primary-color;
      }

      &.is-checked+.el-radio__label {
        color: @primary-color;
      }
    }
  }
}

.el-checkbox {
  .el-checkbox__label {
    font-size: 14px;
    color: @gray-600;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: @primary-color;
    border-color: @primary-color;
  }
}

// ============================================
// 底部按钮样式
// ============================================
.form-actions {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid @gray-200;

  .el-button {
    margin: 0 10px;
    padding: 12px 40px;

    &.el-button--primary {
      background-color: @primary-color;
      border-color: @primary-color;

      &:hover {
        background-color: @primary-hover;
        border-color: @primary-hover;
      }
    }

    &:not(.el-button--primary) {
      background-color: #fff;
      border-color: @gray-300;
      color: @gray-600;

      &:hover {
        color: @primary-color;
        border-color: @primary-color;
        background-color: @primary-light;
      }
    }
  }
}

// ============================================
// 弹窗样式 - 添加内容
// ============================================
.add-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid @gray-200;
    background: @gray-50;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: @gray-700;
    }

    .el-dialog__close {
      font-size: 18px;
      color: @gray-500;

      &:hover {
        color: @gray-700;
      }
    }
  }

  /deep/ .el-dialog__body {
    padding: 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 15px 20px 20px;
    text-align: center;
    border-top: 1px solid @gray-200;
  }
}

.dialog-content {
  .dialog-title {
    font-size: 14px;
    color: @gray-700;
    margin-bottom: 20px;
    font-weight: 500;
  }

  .type-radio-group {
    .radio-row {
      display: flex;
      margin-bottom: 15px;

      .el-radio {
        margin-right: 30px;
        margin-bottom: 0;

        .el-radio__label {
          font-size: 14px;
          color: @gray-600;
        }
      }
    }
  }

  .error-message {
    color: @error-color;
    font-size: 12px;
    margin-top: 10px;
  }
}

.dialog-footer {
  .el-button {
    padding: 10px 25px;
    font-size: 14px;

    &.el-button--primary {
      background-color: @primary-color;
      border-color: @primary-color;

      &:hover {
        background-color: @primary-hover;
        border-color: @primary-hover;
      }
    }

    &:not(.el-button--primary) {
      background-color: #fff;
      border-color: @gray-300;
      color: @gray-600;

      &:hover {
        color: @primary-color;
        border-color: @primary-color;
        background-color: @primary-light;
      }
    }
  }
}

// ============================================
// 引用弹窗样式
// ============================================
.reference-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid @gray-200;
    background: @gray-50;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: @gray-700;
    }
  }

  .dialog-content {
    padding: 0;
  }

  .reference-table {
    margin-bottom: 20px;
    border: 1px solid @gray-200;
    border-radius: 4px;

    /deep/ .el-table__header {
      th {
        background-color: @gray-100;
        color: @gray-700;
        font-weight: 600;
      }
    }
  }

  .select-btn {
    color: @primary-color;
    font-weight: 500;

    &:hover {
      color: @primary-hover;
    }
  }

  .reference-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .reference-pagination-controls {
      margin-left: auto;
    }
  }

  .dialog-footer {
    text-align: right;
    padding: 10px 0 0 0;
  }
}

// ============================================
// 目录管理弹窗样式
// ============================================
.directory-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid @gray-200;
    background: @gray-50;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: @gray-700;
    }
  }

  .dialog-content {
    padding: 5px;
    min-height: 300px;
  }

  .directory-block {
    margin-bottom: 18px;
    padding: 14px;
    border: 1px solid @gray-200;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);

    &:last-child {
      margin-bottom: 0;
    }
  }

  .directory-block-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid @gray-200;
  }

  .directory-block-title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-700;
    line-height: 1.4;
  }

  .directory-block-tip {
    margin-top: 4px;
    font-size: 12px;
    color: @gray-500;
    line-height: 1.5;
  }

  .directory-toolbar {
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .el-button+.el-button {
      margin-left: 10px;
    }

    &.compact {
      margin-bottom: 0;
      flex-shrink: 0;
    }
  }

  .directory-tree {
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
    border: 1px solid @gray-200;
    border-radius: 4px;
    padding: 10px;
    background-color: @gray-50;
  }

  .blind-tree {
    min-height: 100px;
    max-height: 100px;
    height: 100px;
    overflow: hidden;
  }

  .empty-directory {
    text-align: center;
    padding: 60px 20px;
    color: @gray-500;

    i {
      font-size: 48px;
      color: @gray-400;
      margin-bottom: 15px;
      display: block;
    }

    p {
      font-size: 14px;
      margin: 0;
    }
  }

  .blind-tree .empty-directory {
    height: 100%;
    min-height: 0;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    i {
      font-size: 32px;
      margin-bottom: 8px;
    }
  }

  .directory-list {
    .directory-item {
      margin-bottom: 8px;

      &.child-item {
        margin-left: 30px;
        margin-top: 8px;
      }

      &.grandchild-item {
        margin-left: 30px;
        margin-top: 8px;
      }
    }

    .directory-node {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      background-color: #fff;
      border: 1px solid @gray-200;
      border-radius: 4px;
      transition: all @transition-base ease;

      &:hover {
        background-color: @gray-100;
        border-color: @gray-300;

        .directory-actions {
          opacity: 1;
        }
      }

      i {
        color: @primary-color;
        font-size: 16px;
        margin-right: 8px;
      }

      .directory-name {
        flex: 1;
        font-size: 14px;
        color: @gray-700;
        min-width: 0;
        word-break: break-all;
      }

      .directory-input {
        flex: 1;
        max-width: 300px;
      }

      .directory-actions {
        display: flex;
        align-items: center;
        opacity: 0;
        transition: opacity @transition-base ease;
        margin-left: 10px;

        .el-button {
          padding: 0;
          margin-left: 8px;
          color: @gray-600;

          &:hover {
            color: @primary-color;
          }
        }
      }
    }

    .directory-children {
      margin-top: 8px;
    }
  }
}

.paste-directory-dialog {
  .paste-directory-content {
    .paste-directory-tip {
      margin-bottom: 10px;
      font-size: 13px;
      color: @gray-600;
      text-align: left;
    }
  }
}

// ============================================
// 文件上传进度对话框样式
// ============================================
.upload-progress-content {
  padding: 20px;

  .upload-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 14px;
    color: @gray-700;

    i {
      font-size: 24px;
      color: @primary-color;
      margin-right: 10px;
    }
  }

  .upload-status {
    font-size: 14px;
    color: @gray-600;
  }
}

// ============================================
// 双信封Tab切换样式
// ============================================
.envelope-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 10px;

  .envelope-tab {
    display: inline-block;
    padding: 8px 24px;
    cursor: pointer;
    border: 1px solid @gray-300;
    background: #fafafa;
    color: @gray-600;
    font-size: 14px;
    font-weight: 500;
    transition: all @transition-base ease;
    user-select: none;

    &:first-child {
      border-radius: 4px 0 0 4px;
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
      border-left: none;
    }

    &:hover {
      color: @primary-color;
      background: @primary-light;
      border-color: @primary-color;
    }

    &.active {
      color: #fff;
      background: @primary-color;
      border-color: @primary-color;
    }
  }
}
</style>
